<template>
  <div class="cut-container" :style="{ backgroundImage: `url(${images.bg})`}">
    <div class="banner">
      <img :src="images.banner" alt="">
    </div>
    <div class="main">
      <img :src="images.main" alt="">
    </div>
    <div
      class="button-container"
      id="downloadButton"
      :style="{ backgroundImage: `url(${images.btn})`}"
    >
    </div>
  </div>
</template>

<script>
import title from '@/assets/images/cut/title.png'
import banner from '@/assets/images/cut/banner.png'
import bg from '@/assets/images/cut/bg.jpg'
import main from '@/assets/images/cut/main.png'
import btn from '@/assets/images/cut/btn.png'
import { getWxConfig, patternCutInfo } from '@/api'
import { initWx } from '@/utils/jssdk'

let key = ''
export default {
  name: 'cut',
  data() {
    return {
      images: {
        banner,
        bg,
        main,
        btn
      },
      title
    }
  },
  methods: {
    getScript() {
      return new Promise((resolve) => {
        const $script = document.createElement('script')
        global.document.body.appendChild($script)
        $script.src = 'https://web.cdn.openinstall.io/openinstall.js'
        $script.onload = () => {
          resolve()
        }
      })
    },
    handleClick() {}
  },
  created() {
    const {
      app, patternId,
      sponsorId, type
    } = this.$route.query
    if (app && patternId && sponsorId) {
      patternCutInfo({ patternId: type === '0' ? `S${patternId}` : `Z${patternId}` })
        .then((config) => {
          getWxConfig({ url: window.location.href })
            .then((res) => initWx(res.data))
            .then(() => {
              // eslint-disable-next-line no-undef
              wx.ready(() => {
                const content = {
                  title: config.data.shareTitle,
                  desc: config.data.shareText,
                  link: window.location.href,
                  imgUrl: config.data.shareImg,
                  success: () => {}
                }
                // eslint-disable-next-line no-undef
                wx.updateTimelineShareData(content)
                // eslint-disable-next-line no-undef
                wx.updateAppMessageShareData(content)
              })
            })
        })
      key = app === 'user' ? 'xjpkzs' : 'ou6un5'
      this.getScript()
        .then(() => {
          // eslint-disable-next-line no-undef
          const data = OpenInstall.parseUrlParams()/// openinstall.js中提供的工具函数，解析url中的所有查询参数
          // eslint-disable-next-line no-undef,no-new
          new OpenInstall({
            /* appKey必选参数，openinstall平台为每个应用分配的ID */
            appKey: key,
            /* OpenInstall初始化完成的回调函数，可选 */
            onready() {
              /* 在app已安装的情况尝试拉起app */
              this.schemeWakeup()

              /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
              const m = this; const button = document.getElementById('downloadButton')
              button.onclick = function () {
                m.wakeupOrInstall()
                return false
              }
            }
          }, data)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.cut-container{
  height: 100vh;
  background-position: bottom;
  background-size: contain;
  img{
    width: 100%;
    display: block;
  }
  .button-container{
    margin: 0 auto;
    width: rem(560);
    height: rem(105);
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
